import { css } from '@emotion/core'
import { ShowAni } from '@styles/base.style'
import styled, { ThemeProps, Theme } from '@themes/theme'

export const Hit = (theme: Theme) =>
  css`
    color: ${theme.color.blue};
  `
export const Miss = (theme: Theme) =>
  css`
    color: ${theme.color.red};
  `
export const SpecialCase = (theme: Theme) =>
  css`
    color: ${theme.color.purple};
  `
export const ListHeaderWrap = styled.div`
  display: block;
  height: 42px;
  line-height: 4.2rem;
  padding: 0 14px;
  background: ${props => props.theme.color.contentsBg};
  .ant-select {
    top: 10px;
    float: right;
    width: 110px;
    margin-right: -6px;
    line-height: 3rem;
  }
  .ant-select-selection {
    height: 24px;
    background: ${props => props.theme.color.contentsBg};
    border: 1px solid ${props => props.theme.color.gray};
    border-radius: 50px;
  }
  .ant-select-selection__rendered {
    height: 24px;
    line-height: 2.4rem;
    .ant-select-selection-selected-value {
      height: 20px;
      .option-txt {
        font-size: ${props => props.theme.font.small};
      }
    }
  }
  .ant-select-arrow .ant-select-arrow-icon {
    display: none;
  }
  .ant-select-selection-selected-value {
    height: 24px;
    font-size: ${props => props.theme.font.small};
  }

  .list-header-tit {
    display: inline-block;
    color: ${props => props.theme.color.gray};
    font-size: ${props => props.theme.font.medium};
  }

  .up-ico {
    z-index: 2;
    position: relative;
    right: 14px;
    float: right;
    width: 5px;
    svg {
      height: auto;
      transform: rotate(180deg);
      path {
        fill: ${props => props.theme.color.gray};
      }
    }
  }
`
export const AccordionListWrap = styled.div`
  position: relative;
  width: 100%;
  /* 픽 리스트 */
  .am-accordion .am-accordion-item .am-accordion-header {
    height: auto;
    max-height: 98px;
    padding: 10px 14px;
    line-height: 1.7rem;
    border: ${props => props.theme.border.line};
    i {
      display: none;
    }
  }
  .am-accordion .am-accordion-item-active .arrow svg {
    transform: rotate(180deg);
  }
  .am-accordion .am-accordion-item .am-accordion-content .am-accordion-content-box {
    background: ${props => props.theme.color.accordion1};
  }
`
export const PickWrap = styled.div`
  .pick-date {
    color: ${props => props.theme.color.gray};
  }
  .pick-list-tit {
    display: block;
    width: 100%;
    margin: 5px 0 7px;
    font-size: ${props => props.theme.font.medium};
  }
  .pick-list {
    display: flex;
    justify-content: space-between;
    &--pickster-info {
      flex: 1;
      position: relative;
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      &::before {
        content:'';
        display: block;
        position: absolute;
        top: 5px;
        right: 0;
        height: 26px;
        border-right: 1px solid ${props => props.theme.color.gray};
      }
      * {
        font-size: ${props => props.theme.font.small};
      }
      &--pickster-img {
        img {
          position: relative;
          top: 5px;
          width: 24px;
        }
      }
      &--pickster {
        width: calc(100% - 35px);
        padding-left: 8px;
        &--name {
          display: block;
        }
        &--hit-rate {
          color: ${props => props.theme.color.gray};
        }
        &--percent {
            float: right;
            color: ${props => props.theme.color.gray};
          }
      }
    }
    &--pick-info {
      flex: 2;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      padding-left: 5%;
      font-size: ${props => props.theme.font.small};
      &--sub {
        height: 30px;
        /* 픽 판매가 */
        &.price {
          width: 50%;
        }
        &--txt {
          display: block;
          font-size: ${props => props.theme.font.small};
          color: ${props => props.theme.color.gray};
        }
        &--num {
        }
        &--money-wrap {
          display: flex;
          justify-content: flex-end;
          flex-wrap: nowrap;
          height: 18px;
          line-height: 1.8rem;
          &--money {
            display: inline-block;
            width: calc(100% - 18px);
            text-align: right;
          }
          &--icon {
            margin-left: 4px;
            svg {
              position: relative;
              top: 1px;
              width: 14px;
              height: 14px;
            }
            &.message-modal {
              color: ${props => props.theme.color.modalTxt};
              svg {
                top: 3px;
              }
            }
          }
        }
      }
    }
  }

/* 픽 공유 모달 */
  &.modal {
    .pick-date {
      color: ${props => props.theme.color.modalSubTxt};
    }
    .pick-list-tit {
      color: ${props => props.theme.color.modalTxt};
    }
    .pick-list {
      &--pickster-info {
        &::before {
          border-color: ${props => props.theme.color.modalTxt};
        }
        &--pickster {
          &--name {
            color: ${props => props.theme.color.modalTxt};
          }
          &--hit-rate, &--percent {
            color: ${props => props.theme.color.modalSubTxt};
          }
        }
      }
      &--pick-info--sub {
        &--txt {
          color: ${props => props.theme.color.modalSubTxt};
        }
        &--num, &--money-wrap--money {
          color: ${props => props.theme.color.modalTxt};
        }
        .point {
          color: ${props => props.theme.color.modalOrange};
        }
      }
    }
    .item-list {
      position: relative;
        top: -2px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &--item {
        width: 85px;
        height: 80px;
        background: ${props => props.theme.color.accordion1};
        border-radius: 10px;
        &--img {
          position: relative;
          top: 50%;
          display: block;
          width: auto;
          height: 75px;
          margin: 0 auto;
          transform: translate(0,-50%);
        }
      }
      &--item-quantity {
        &--txt {
          margin: 0 20px 0 25px;
          color: ${props => props.theme.color.modalSubTxt};
          font-size: ${props => props.theme.font.xlarge};
        }
        &--num {
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.xlarge};
        }
      }
    }
  }
/* 픽 공유 메세지 */
  &.message {
    padding: 10px 14px;
  }
`
const PickStyle = (props: ThemeProps) =>
  css`
    display: inline-block;
    width: 55px;
    height: 18px;
    margin-right: 6px;
    line-height: 1.8rem;
    text-align: center;
    font-size: ${props.theme.font.small};
    border-radius: 50px;
  `
export const PickType = styled.span`
  ${PickStyle};
  color: ${props => props.theme.color.themeTxt};
  border: 1px solid ${props => props.theme.color.themeTxt};
`
export const CircleDownStyle = styled.span`
  position: relative;
  top: 1px;
  left: 6px;
  width: 10px;
  svg {
    transition: all 0.3s;
  }
`
export const BettingButtonWrap = styled.div`
  z-index: 2;
  position: absolute;
  top: 0;
  right: 0;
`
export const BettingButtonStyle = (theme: Theme) => css`
  position: absolute;
  top: 10px;
  right: 20px;
  width: 60px;
  height: 30px;
  padding: 0;
  line-height: 1.5rem;
  font-size: ${theme.font.medium};
  &::before {
    display: none;
  }
`
export const ButtonWrap = styled.div`
  z-index: 2;
  position: absolute;
  top: 0;
  right: 0;
  border: 1px solid ${props => props.theme.color.TP};
`
const IcoStyle = css`
  display: inline-block;
  width: 26px;
  height: 26px;
  margin: 0 10px 0 0;
  opacity: 0;
  background: none;
  transition: all 0.3s ease-in-out;
`
export const IconButton = styled.button`
  ${IcoStyle};
  padding: 0;
  border: none; /* 픽거래소 +버튼 클릭 시 나오는 라인 제거 */
`
export const SettingStyle = (theme: Theme) => css`
  span {
    z-index: 9;
    position: absolute;
    top: 18px;
    right: 14px;
    margin: 0;
    padding: 0;
  }
  span svg {
    width: 28px;
    transition: all 0.3s;
  }
  input {
    z-index: 9999;
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    border: 0;
    clip: rect(0, 0, 0, 0);
  }

  /* + 버튼 */
  .expand svg {
    transform: rotate(45deg);
  }
  .expand + .setting-wrap {
    width: 65px;
    height: 28px;
    .icon-btn {
      opacity:1;
      /* animation: ${ShowAni} 0.6s 1 ease-in-out forwards; */
    }
  }
  .setting-wrap {
    position: absolute;
    width: 0;
    height: 0;
    right: 50px;
    top: 19px;
    transition: all 0.2s ease-in-out;
    overflow: hidden;
  }
`
export const PickHiddenWrap = styled.div`
  position: relative;
  width: 100%;
  padding: 6px 20px 0;
  line-height: 2.2rem;
  * {
    font-size: ${props => props.theme.font.small};
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: ${props => props.theme.border.line};
  }
  &:last-of-type::before {
    display: none;
  }
  .league-name {
    text-align: left;
    margin-bottom: -4px;
  }
  .pick-match-info {
    display: flex;
    justify-content: space-between;
    &--date {
      flex:1;
      text-align: left;
      color: ${props => props.theme.color.gray};
    }
    &--team {
      flex: 3;
      display: flex;
      max-width: calc(100% - 80px);
      justify-content: flex-end;
      &--name {
        max-width: 40%;
        color: ${props => props.theme.color.themeTxt};
      }
      &--score {
        width: auto;
        text-align: center;
        margin: 0 2px;
        font-size: ${props => props.theme.font.medium};
        &:not(.team-score) {
          margin: 0 6px;
          color: ${props => props.theme.color.gray};
        }
        &.team-score {
          max-width: 28%;
        }
        &--num {
          margin: 0 4px;
          font-size: ${props => props.theme.font.large};
          &.win {
            color: ${props => props.theme.color.red};
          }
          &.lose {
            color: ${props => props.theme.color.disableTxt};
          }
        }
      }
    }
  }
  .fold-wrap {
    border-bottom: ${props => props.theme.border.line};
    &:last-of-type {
      border: none;
    }
    &--bottom {
      z-index:1;
      position: relative;
      display: flex;
      justify-content: space-between;
      &::before {
        content:'';
        z-index: -1;
        display:block;
        position: absolute;
        top:0;
        left:-20px;
        width: 100vw;
        height: 100%;
        background: ${props => props.theme.color.accordion2};

      }
      &:not(:first-of-type) {
        &::before {
          border-top: 1px solid ${props => props.theme.color.accordion1};
        }
      }
      &--select-result {
        display: flex;
        justify-content: flex-end;
        .txt {
          color: ${props => props.theme.color.disableTxt};
          font-size: ${props => props.theme.font.small};
        }
        .hyphen {
          margin: 0 4px;
        }
        .type {
          color: ${props => props.theme.color.gray};
        }
        .bet-hit-state {
          width: 38px;
          text-align: right;
        }
      }
    }
  }

  /* 픽 판매 모달 */
  &.pick-sale-modal {
    background: ${props => props.theme.color.modalSubBg2};
    .league-name {
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.medium};
    }
    .pick-match-info {
      &--date {
        color: ${props => props.theme.color.modalSubTxt};
      }
      &--team {
        &--name {
          margin-top: -1px;
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.medium};
        }
        &--score {
          font-size: ${props => props.theme.font.large};
        }
      }
    }
    .fold-wrap {
      &--bottom {
        &::before {
          background: ${props => props.theme.color.modalSubBg};
        }
        &--market-name {
          color: ${props => props.theme.color.modalSubTxt};
        }
        &--select-result {
          .hyphen, .type {
            color: ${props => props.theme.color.modalTxt};
          }
        }
      }
    }
  }
`

export const PickMessageWrap = styled.div`
  position: relative;
  margin-bottom: 14px;
  padding: 14px;
  text-align: left;
  border-radius: 6px;
  background: ${props => props.theme.color.themeTxt};
  .message-pick-btn {
    position: absolute;
    top: 7px;
    right: 11px;
    width: auto;
    height: 30px;
    color: ${props => props.theme.color.modalyellow};
    font-size: ${props => props.theme.font.small};
    background: none;
    border-radius: 0;
    // 픽 구매 버튼
    &.buy {
      text-decoration: underline;
    }
    // 픽 첨부 해제 버튼
    &.release {
      .x-ico {
        position: relative;
        width: 13px;
        height: 13px;
        transform: rotate(45deg);
        &::before, &::after {
          content:'';
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: ${props => props.theme.color.modalgray};
        }
        &::before {
          width: 1px;
          height: 13px;
        }
        &::after {
          width: 13px;
          height: 1px;
        }
      }
    }
  }
  .bet-date {
    color: ${props => props.theme.color.modalSubTxt};
    font-size: ${props => props.theme.font.small};
    font-weight: ${props => props.theme.fontW.medium};
  }
  .pick-list-tit {
    margin: 6px 0;
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.small};
    font-weight: ${props => props.theme.fontW.medium};
  }
  .pick-list {
    display: flex;
    justify-content: space-between;
    .pickster-info {
      flex: 1.1;
      position: relative;
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      &::before {
        content:'';
        display: block;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-45%);
        height: 19px;
        border-right: 1px solid ${props => props.theme.color.modalSubBg};
      }
      .pickster-img {
        position: relative;
        top: 5px;
        width: 24px;
        height: 22px;
      }
      .pickster {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
        padding: 0 3vw 0 8px;
        &--name {
          width: 100%;
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.small};
          font-weight: ${props => props.theme.fontW.medium};
        }
        &--hit-rate {
          color: ${props => props.theme.color.modalSubTxt};
          font-size: ${props => props.theme.font.small};
          font-weight: ${props => props.theme.fontW.medium};
        }
        &--percent {
          color: ${props => props.theme.color.modalSubTxt};
          font-size: ${props => props.theme.font.small};
          font-weight: ${props => props.theme.fontW.medium};
        }
      }
    }
    .pick-info {
      flex: 2;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      padding-left: 3vw;
      font-size: ${props => props.theme.font.small};
      .pick-info-item {
        display:flex;
        flex-flow: column;
        align-items: center;
        height: 30px;
        /* 픽 판매가 */
        &.price {
          width: 55%;
          align-items: flex-start;
        }
        .txt {
          display: block;
          font-size: ${props => props.theme.font.small};
          color: ${props => props.theme.color.modalSubTxt};
        }
        .num {
          color: ${props => props.theme.color.modalTxt};
          font-weight: ${props => props.theme.fontW.medium};
          &.point {
            color: ${props => props.theme.color.modalyellow};
          }
        }
        .money-wrap {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          flex-wrap: nowrap;
          width: 100%;
          height: 18px;
          line-height: 1.8rem;
          color: ${props => props.theme.color.modalTxt};
          &--money {
            display: inline-block;
            width: calc(100% - 18px);
            text-align: right;
            color: ${props => props.theme.color.modalTxt};
            font-weight: ${props => props.theme.fontW.medium};
          }
          svg {
            width: 14px;
            height: 14px;
            margin-left: 4px;
          }
        }
      }
    }
    &.pc-pick-list {
      .pickster {
        padding: 0 14px 0 8px;
      }
      .pick-info {
        padding-left: 14px;
      }
    }
  }
  &.modal {
    height: 103px;
    margin-bottom: 0;
    background: ${props => props.theme.color.modalBg};
  }

`
